class ProductMediaGallery extends ModalDialog {
  constructor() {
    super();
    this.mainSliderElement = this.querySelector("[data-main-product-slider]");
    this.mainSliderDrag = Number(this.mainSliderElement.dataset.slidesCount) !== 1;
    this.mainSlider = {
      element: this.querySelector('[data-main-product-slider]'),
      instance: null,
      options: {
        pagination: false,
        arrows: false,
        type: 'loop',
        drag: this.mainSliderDrag,
      }
    };
    this.thumbsSlider = {
      element: this.querySelector('[data-main-product-thumbs]'),
      nextArrow: this.querySelector('[data-thumbs-next]'),
      instance: null,
      options: {
        pagination: false,
        arrows: false,
        isNavigation: true,
        perPage: 3,
        gap: '10px',
        type: Number(this.mainSliderElement.dataset.slidesCount) > 2 ? "loop" : "slide",
        breakpoints: {
          749: {
            gap: '6px',
          }
        }
      }
    }
    this.controls = this.querySelectorAll('[data-control]');

    this.controls.forEach((control) => {
      control.addEventListener('click', this.onControlClick.bind(this));
    });

    if (this.thumbsSlider.nextArrow) {
      this.thumbsSlider.nextArrow.addEventListener('click', (event) => {
        this.onControlClick(event, this.thumbsSlider.instance);
      })
    }

    this.initSlider();
  }

  conectedCallback() { 
    this.initSlider();
  }

  onControlClick(event, sliderInstance = this.mainSlider.instance) {
    event.preventDefault();

    if (!sliderInstance) {
      return;
    }

    const action = event.target.hasAttribute('data-prev') ? '<' : '>';

    sliderInstance.go(action);
  }

  initSlider() {     
    if (this.thumbsSlider.element) {
      this.thumbsSlider.instance = new Splide(
        this.thumbsSlider.element,
        this.thumbsSlider.options
      ).mount();
    }

    this.mainSlider.instance = new Splide(
      this.mainSlider.element,
      this.mainSlider.options
    )

    this.thumbsSlider.instance
      ? this.mainSlider.instance.sync(this.thumbsSlider.instance).mount()
      : this.mainSlider.instance.mount();
  }

  show(opener) {
    super.show(opener);    
    this.goToSlide(this.openedBy.dataset.mediaId);      
  }

  goToSlide(mediaId) {
    if (this.mainSlider.instance) {
      const media = this.mainSlider.element.querySelector(`[data-media-id="${mediaId}"]`)

      if (!media) {
        return;
      }

      const slideIndex = this.mainSlider.instance.Components.Elements.slides.findIndex((slide) => (
        slide.dataset.mediaId === mediaId
      ));

      setTimeout(() => {
        this.mainSlider.instance.go(slideIndex);                     
      }, 500);
    }   
  }
}

customElements.define('product-media-gallery', ProductMediaGallery);
